import GoogleTagManagerViewMiniCart from '@reaffiliates/GoogleTagManager/GoogleTagManagerViewMiniCart';
const ReaffiliatesViewMiniCart = () => GoogleTagManagerViewMiniCart();
export default ReaffiliatesViewMiniCart;